import { Save } from '@mui/icons-material';
import { Box, Button, CircularProgress, Grid2, Stack, Typography } from '@mui/material';
import { useSchoolClass } from 'pages/SchoolClass/hooks/useSchoolClass';
import { useFormContext } from 'react-hook-form';
import { SchoolClassFormData } from 'services/SchoolClass/schemas';
import { ClassSidebarSummary } from './ClassSidebarSummary';
import { BasicDataCard } from './BasicDataCard';
import { DangerZoneCard } from './DangerZoneCard';
import { StudentsCard } from './StudentsCard';

type SchoolClassHookReturn = ReturnType<typeof useSchoolClass>;

export interface ClassSettingsTabProps {
  state: SchoolClassHookReturn['state'];
  actions: SchoolClassHookReturn['actions'];
}

export function ClassSettingsTab({ state, actions }: ClassSettingsTabProps) {
  const { handleSubmit } = useFormContext<SchoolClassFormData>();

  const isSaving = state.isCreating || state.isUpdating;
  const isNew = state.selectedId === 'new';

  const buttonText = isSaving
    ? 'Salvando...'
    : isNew
      ? 'Cadastrar Nova Turma'
      : 'Salvar Alterações';

  const subtitleText = isNew
    ? 'Preencha os dados abaixo para cadastrar uma nova turma no sistema.'
    : 'Atualize os dados cadastrais e gerencie os alunos matriculados nesta turma.';

  return (
    <Box sx={{ width: '100%', display: 'flex', flex: 1 }}>
      <Grid2 container spacing={3} alignItems="stretch" sx={{ width: '100%' }}>

        {/* COLUNA ESQUERDA: FORMULÁRIO */}
        <Grid2 size={{ xs: 12, lg: 7 }} sx={{ display: 'flex', flexDirection: 'column' }}>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3 }}>
            <Box>
              <Typography variant="h5" fontWeight="bold" color="text.primary" gutterBottom>
                Configurações e Gestão
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {subtitleText}
              </Typography>
            </Box>

            <Button
              variant="contained"
              color="primary"
              startIcon={isSaving ? <CircularProgress size={16} color="inherit" /> : <Save />}
              disableElevation
              onClick={handleSubmit(actions.onSave)}
              disabled={isSaving || state.isFetchingDetail}
              sx={{ textTransform: 'none', fontWeight: 'bold' }}
            >
              {buttonText}
            </Button>
          </Box>

          <Stack spacing={3} sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
            <BasicDataCard />
            <StudentsCard />
            {state.selectedId !== 'new' && (
              <DangerZoneCard state={state} actions={actions} />
            )}
          </Stack>
        </Grid2>

        {/* COLUNA DIREITA: CONTEXTO */}
        <Grid2 size={{ xs: 12, lg: 5 }} sx={{ display: 'flex', flexDirection: 'column' }}>
          <ClassSidebarSummary state={state} />
        </Grid2>

      </Grid2>
    </Box>
  );
}